export default class {

    constructor ($state, $translate, lodash, moment, COURSE_TRAINING_TYPE_ENUM, OccurrenceResource, PrivilegeService) {
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.OccurrenceResource = OccurrenceResource;
        this.$translate = $translate;
        this.lodash = lodash;
        this.moment = moment;
        this.$state = $state;
        this.canManageCourses = PrivilegeService.canManageCourses();
        this.apiDateRequestFormat = 'YYYY-MM-DD';
        this.apiDateResponseFormat = 'YYYY-MM-DD HH:mm';
    }

    getTooltip (event) {
        const isOnline = event.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.ONLINE;
        const isTest = event.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.TEST;
        const isFeedback = event.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK;

        const rows = [];
        rows.push(`<b>${event.title}</b>`);

        if (isOnline || isFeedback) {
            rows.push(`${this.$translate.instant('planning.Type')}: ${this.COURSE_TRAINING_TYPE_ENUM.LABELS[event.type]}`);
        }
        else {
            const start = event.start.format('DD.MM HH:mm');
            const end = isTest ? event.end.format('DD.MM') : event.end.format('DD.MM HH:mm');
            rows.push(`${start} - ${end}`);
        }
        rows.push(`${this.$translate.instant('planning.Participants')}: ${event.participantCount ? event.participantCount : 0}`);
        if (event.trainers) {
            rows.push(`${this.$translate.instant('planning.Trainers')}: ${event.trainers}`);
        }
        if (!isOnline && !isFeedback) {
            rows.push(`${this.$translate.instant('planning.Location')}: ${event.room}`);
        }
        return `<p>${rows.join('<br>')}</p>`;
    }

    updateEvents (filter, callback) {
        this.eventsColorMap = { };

        // two different colors brown and black for webinar and classroom events
        this.eventsColorMap[this.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM] = 'color01';
        this.eventsColorMap[this.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR] = 'color02';

        this.OccurrenceResource.getEvents(filter).$promise
            .then((events) => {
                // Filter events to only include classroom and webinar
                const filteredEvents = events.filter(event =>
                    event.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.CLASSROOM ||
                    event.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.WEBINAR
                );

                filteredEvents.forEach((event) => {
                    event.start = this.getDateInResponseApiFormat(event.start);
                    event.end = this.getDateInResponseApiFormat(event.end);
                    event.className = this.eventsColorMap[event.type];
                    if (this.canManageCourses) {
                        event.url = this.$state.href('authorized.courses.courses.edit.occurrence.edit.general', {
                            id: event.courseId,
                            occurrenceId: event.occurrenceId
                        });
                    }
                });
                callback(filteredEvents);
            });
    }

    getDateInRequestApiFormat (date) {
        return this.moment(date).format(this.apiDateRequestFormat);
    }

    getDateInResponseApiFormat (date) {
        return this.moment.utc(date).local().format(this.apiDateResponseFormat);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/calendar/index.js